import { render, staticRenderFns } from "./list.vue?vue&type=template&id=3ab2b17c&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab2b17c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ab2b17c')) {
      api.createRecord('3ab2b17c', component.options)
    } else {
      api.reload('3ab2b17c', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=3ab2b17c&scoped=true", function () {
      api.rerender('3ab2b17c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchase/list.vue"
export default component.exports